
import { reset } from "echarts/lib/visual/seriesColor";
import {
  SEND_RESET_CODE_REQUEST,
  SEND_RESET_CODE_SUCCESS,
  SEND_RESET_CODE_FAILURE,
  VERIFY_RESET_CODE_REQUEST,
  VERIFY_RESET_CODE_SUCCESS,
  VERIFY_RESET_CODE_FAILURE,
  RESET_USER,
  RESET_USER_SUCCESSFUL,
  RESET_USER_FAILED,
  CLEAR_SUCCESS,
  RESET_STEP
} from "./actionTypes"

const initialState = {
  stage: 1,
  loading: false,
  success: false,
  resetPassSuccess: false,
  resetPassError: null,
  message: null,
  email: null,
  user: null,
}

const account = (state = initialState, action) => {
  switch (action.type) {
    case SEND_RESET_CODE_REQUEST:
      return {
        ...state,
        loading: true,
        success: false,
        resetPassError: null,
        message: null
      }

    case SEND_RESET_CODE_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        stage: 2,
        email: action.payload.email,
        message: action.payload.message || "Verification code sent.",
      }

    case SEND_RESET_CODE_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        resetPassError: action.payload,
        message: null
      }

    case VERIFY_RESET_CODE_REQUEST:
      return {
        ...state,
        loading: true,
        success: false,
        resetPassError: null,
        message: null
      }

    case VERIFY_RESET_CODE_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        stage: 3,
        message: action.payload.message || "Email verified.",
      }

    case VERIFY_RESET_CODE_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        resetPassError: action.payload,
        message: null
      }

    case RESET_USER:
      return {
        ...state,
        loading: true,
        success: false,
        resetPassError: null,
        message: null
      }

    case RESET_USER_SUCCESSFUL:
      return {
        ...state,
        loading: false,
        user: action.payload,
        success: true,
        resetPassSuccess: true,
        stage: 1,
        resetPassError: null,
      }

    case RESET_USER_FAILED:
      return {
        ...state,
        user: null,
        loading: false,
        success: false,
        resetPassError: action.payload
      }

    case CLEAR_SUCCESS:
      return {
        ...state,
        resetPassSuccess: false,
        resetPassError: null,
        success: false,
        message: null,
      }

    case RESET_STEP:
      return {
        ...state,
        stage: 1,
        loading: false,
        success: false,
        resetPassSuccess: false,
        resetPassError: null,
        message: null,
        email: null,
        user: null,
      }

    default:
      return state;
  }
};

export default account
